import axios from "axios";
import { ENDPOINTS } from "../jsx/services/ENDPOINT";


const EXPENSE_API = `${ENDPOINTS.BASE_2}/expense`;

// ================= EXPENSE APIs =================

// Get all expenses
export const getAllExpense = () => {
  return axios.get(`${EXPENSE_API}/`);
};

//  Create expense
export const createExpense = (data) => {
  return axios.post(`${EXPENSE_API}/create`, data);
};

//  Edit expense
export const editExpense = (data) => {
  if (data?.id) {
    return axios.put(`${EXPENSE_API}/${data.id}`, data);
  }
  // Legacy fallback
  return axios.post(`${EXPENSE_API}/edit`, data);
};

//  Delete full expense
export const deleteExpense = (id) => {
  return axios.delete(`${EXPENSE_API}/${id}`);
};

//  Delete single expense item
export const deleteExpenseItem = (id) => {
  return axios.delete(`${EXPENSE_API}/item/${id}`);
};

//  Service requests
export const getServiceRequests = () => {
  return axios.get(`${EXPENSE_API}/service-requests`);
};
